import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Resource} from 'app/constants/resource';

import {ENTITIES_SETUP_BASE_URL} from 'app/app.constants';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';
import {IVatType, VatType} from 'app/blocks/model/vat-type-model';
import {VatTypeService} from 'app/blocks/service/api/vat-type.service';

@Injectable({
    providedIn: 'root'
})
export class VatTypeResource extends AbstractEntityResource<IVatType> {
    constructor(vatTypeService: VatTypeService, router: Router) {
        super(
            Resource.VAT_TYPE,
            vatTypeService,
            new EntityNavigator(ENTITIES_SETUP_BASE_URL, Resource.VAT_TYPE, router),
            new EntityUrlProvider(ENTITIES_SETUP_BASE_URL, Resource.VAT_TYPE),
            (entity?) => new VatType(entity),
            (entity) => entity.id
        );
    }
}
